import { Button } from '@/components/ui/button';
import { useCustomerBasis } from '@/features/customer-detail/hooks/use-customer-basis';
import { DialogStateManager } from '@/features/dialog/dialog-provider';
import { TraskCreateDialog } from '@/features/tasks/components/task-create-dialog';
import { useLocale } from '@/lib/hooks/use-locale';
import { SearchEntity } from '@/server/types/search-types';
import { PlusIcon } from '@heroicons/react/24/outline';

interface Props {
    itemTitle: string;
    customerId: string | undefined;
}

export const InventoryActions = ({ itemTitle, customerId }: Props) => {
    const { t } = useLocale();
    const { data: customerBasics } = useCustomerBasis({ customerId });

    return (
        <Button
            variant="primary"
            icon={PlusIcon}
            onClick={() => {
                DialogStateManager.show(TraskCreateDialog, {
                    description: `${itemTitle}:\n`,
                    links: customerId
                        ? [
                              {
                                  modelType: SearchEntity.Customer,
                                  modelId: customerId,
                                  title: customerBasics?.customerName || '',
                              },
                          ]
                        : undefined,
                });
            }}
        >
            {t('header__new_task', { ns: 'product-details' })}
        </Button>
    );
};
